import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Container } from 'reactstrap';
import ScoreCardItem from "./ScoreCardItem";

const ScoreCard = props => {
    return (
        <Container>
            {props.header}
            {props.results.map(r => (
                <ScoreCardItem
                    key={r.id}
                    question={r.question}
                    answer={r.answer}
                    reason={r.reason}
                />
            ))}
        </Container>
    );
};

export default ScoreCard;
